import React, { memo } from 'react';
import StyleConstants from 'js/StyleConstants';

import { createTheme, darken, ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as LegacyThemeProvider } from '@mui/styles';

import { grey } from '@mui/material/colors';

const muiTheme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: [
      '"Helvetica Neue"',
      // 'Nunito',
      // 'Roboto',
      'Arial',
      'sans-serif',
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    button: {
      textTransform: 'none',
    },
  },
  spacing: 8,
  palette: StyleConstants.palette,
  components: {
    MuiAppBar: {
      colorDefault: {
        backgroundColor: '#ffffff',
      },
      colorPrimary: {
        backgroundColor: StyleConstants.palette.primary.main,
      },
    },
    MuiPickersDay: {
      day: {
        color: '#78a22f',
        '& span p': {
          fontWeight: '800 !important',
        },
      },
      dayDisabled: {
        '& span p': {
          fontWeight: '400 !important',
        },
      },
      current: {
        color: '#78a22f',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'inherit',
      },
      colorInherit: {
        backgroundColor: StyleConstants.palette.primary.main,
        color: StyleConstants.palette.primary.contrastText,
        '&:hover': {
          backgroundColor: darken(StyleConstants.palette.primary.main, 0.15),
        },
      },
      contained: {
        backgroundColor: '#fff',
        color: '#000',
        '&:hover': {
          backgroundColor: grey['200'],
        },
      },
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
        textPrimary: {
          color: StyleConstants.colors.black,
        },
        outlined: {
          backgroundColor: '#fff',
          borderColor: grey['400'],
          color: '#000',
          '&:hover': {
            backgroundColor: grey['200'],
            borderColor: grey['400'],
          },
        },
      },
    },
    MuiFab: {
      root: {
        '&:hover': {
          backgroundColor: grey['200'],
        },
      },
    },
    MuiIconButton: {
      colorPrimary: {
        '&:hover': {
          backgroundColor: darken(StyleConstants.palette.primary.main, 0.15),
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        colorPrimary: {
          color: StyleConstants.colors.black,
        },
      },
    },
  },
});

const MUITheme = ({ children }) => {
  return (
    <ThemeProvider theme={muiTheme}>
      {/* @mui/styles 6 uses a separate theme context from Material UI 7. */}
      <LegacyThemeProvider theme={muiTheme}>{children}</LegacyThemeProvider>
    </ThemeProvider>
  );
};

export default memo(MUITheme);
